import {useQuery} from 'react-query'

async function getExamsAccepted()
{
    const response = await fetch(`${process.env.REACT_APP_API_KEY}api/v1/teacher/exams/status/accept-exams`
    )
    return response.json()
}

export const useAllExamsAccepted = ()=>
{
    return useQuery('get-accepted-exams',()=>getExamsAccepted())
}